import { IOwnedViolation, IViolation } from '../../model/base/annotation';
import { Named } from '../../model/base/named';

export enum PublishStatus {
    Succeeded,
    Failed,
    ValidationFailed,
    NothingToPublish,
    Cancelled,
    CrossPublishing
}

export interface ISettingViolation extends IViolation {
    name: string;
    icon: string;
    route: string;
}

export interface IPublishViolations {
    resourceViolations: IOwnedViolation[];
    settingsViolations: ISettingViolation[];
}

export interface IPublishResult {
    publishStatus: PublishStatus;
    editedNameds?: Named[];
    violations?: IPublishViolations;
}
